/**
 * Usage:
 *
 *  <form data-bind="form: {Function}">
 *      <input type="text" data-bind="formField: {core/FormFields.field}" />
 *      <button data-bind="formSubmit: true">Submit</button>
 *  </form>
 */
define('ko/customBinding/form',['underscore', 'knockout', 'jquery', 'core/Form'], function(_, ko, $, Form) {

    ko.bindingHandlers.form = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            bindingContext._form = new Form(valueAccessor());

            ko.applyBindingsToNode(
                element,
                {
                    submit: function() {
                        bindingContext._form.submit();
                        return false;
                    }
                },
                bindingContext
            );

            $(element).append('<input type="submit" tabindex="-1" style="position:absolute;left:-9999px;" />');

        }
    };

    ko.bindingHandlers.formField = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            var formField = valueAccessor();

            bindingContext._form.attachField(formField);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                bindingContext._form.detachField(formField);
            });

        }
    };

    ko.bindingHandlers.formSubmit = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            ko.applyBindingsToNode(
                element,
                {
                    css: {
                        busy: bindingContext._form.isBusy,
                        loading: bindingContext._form.isSubmitting
                    },
                    disable: bindingContext._form.submitIsDisabled
                },
                bindingContext
            );

            $(element).attr('type', 'submit');

        }
    };

});

